var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchShopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23083 7.1754L0 5.82759L3.75678 1.43912L3.23083 7.1754Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7691 7.1754L17.9999 5.82759L14.2432 1.43912L14.7691 7.1754Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.601 0.899994C11.6118 1.27493 11.5525 1.64838 11.4267 1.99818C11.3008 2.34799 11.111 2.66702 10.8684 2.93634C10.6258 3.20567 10.3354 3.41981 10.0145 3.56604C9.69354 3.71227 9.34857 3.78763 9.00005 3.78763C8.65153 3.78763 8.30656 3.71227 7.98562 3.56604C7.66467 3.41981 7.37429 3.20567 7.1317 2.93634C6.88912 2.66702 6.69926 2.34799 6.57341 1.99818C6.44757 1.64838 6.38829 1.27493 6.3991 0.899994L3.75684 1.43912V15.3H14.2433V1.43912L11.601 0.899994Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchShopIcon);
export default __webpack_public_path__ + "static/media/MerchShopIcon.91160d6da77e32711443dac88586227c.svg";
export { ForwardRef as ReactComponent };